import React from 'react'
import { Grid } from '@mui/material'
import TaskUpdateModal from './TaskUpdateModal'
import TaskArchiveModal from './TaskArchiveModal'
import { Task } from '../../../../redux/task/types'

interface TaskActionsProps {
  taskData: Task
}

const TaskActions: React.FC<TaskActionsProps> = ({ taskData }) => {
  return (
    <Grid container spacing={{ md: 0.5, lg: 1 }} justifyContent='center' alignItems='center'>
      <Grid>
        <TaskUpdateModal taskDetails={taskData} />
      </Grid>
      <Grid>
        <TaskArchiveModal id={taskData.id} />
      </Grid>
    </Grid>
  )
}

export default TaskActions
